import React, { ReactNode } from 'react';

import { Navigate, useLocation, useMatch } from 'react-router-dom';

import { isAuthenticated } from 'global-services/OhsAuthenticate';
import { ModuleUrl } from 'global-services/constants/OhsRoutes';

interface IProps {
  children: ReactNode;
}

function OhsRequireAuth({ children }: IProps): any {
  const location = useLocation();
  const match = useMatch(ModuleUrl.QrCodeGuest);
  const isGuestAuthenticated = match !== null && !!match?.params?.token;

  const newLocation = {
    ...location,
    pathname: `${location.pathname}${location.search}`,
  };

  return isAuthenticated() || isGuestAuthenticated ? (
    children
  ) : (
    <Navigate to="/login" state={{ from: newLocation }} replace />
  );
}

export default OhsRequireAuth;
